import { Link } from 'react-router-dom';
import { ExternalLink, MessageCircle, ArrowRight } from 'lucide-react';
import { useApp } from '../lib/app-context';
import { useAppearance, brandText } from '../lib/appearance';
import { BrandAvatar, BrandCover } from '../components/Brand';
import { TelegramAvatar } from '../components/TelegramAvatar';
import { MediaGallery } from '../components/MediaGallery';

function visit(url:string) {
  try { if(new URL(url).protocol!=='https:')return; }catch{return;}
  const tg=window.Telegram?.WebApp;
  if(tg?.initData)url.startsWith('https://t.me/')?tg.openTelegramLink(url):tg.openLink(url);
  else window.open(url,'_blank','noopener,noreferrer');
}
export function ShowcaseProducts({heading}:{heading?:string}) {
  const a=useAppearance();
  const slots=[1,2,3].filter(i=>a[`showcase_image_${i}`]||a[`showcase_title_${i}`]||a[`showcase_body_${i}`]||a[`showcase_url_${i}`]);
  if(!slots.length)return null;
  return <section className="showcase-products" aria-label={heading||'商品展示'}>
    {heading&&<h2 className="showcase-products-heading">{heading}</h2>}
    {slots.map(i=><article className="showcase-product" key={i}>
      <MediaGallery variant="thumbnails" items={[{src:a[`showcase_image_${i}`]}]}/>
      {a[`showcase_title_${i}`]&&<h2>{a[`showcase_title_${i}`]}</h2>}{a[`showcase_body_${i}`]&&<p>{brandText(a[`showcase_body_${i}`],a)}</p>}
      {a[`showcase_url_${i}`]&&<button className="button primary" onClick={()=>visit(a[`showcase_url_${i}`])}>{a[`showcase_button_${i}`]||'了解更多'}<ExternalLink size={17}/></button>}
    </article>)}
  </section>;
}
export function ShowcaseHome() {
  const a=useAppearance();const {config}=useApp();
  return <div className="social-profile showcase-content">
    <BrandCover/>
    <section className="creator-intro"><div className="creator-avatar-row"><BrandAvatar className="social-avatar"/></div>
      <h1>{config?.brand_name}</h1><h2>{a.showcase_title}</h2><p className="creator-bio">{brandText(a.showcase_body,a)}</p>
      <MediaGallery title={a.showcase_gallery_title} subtitle={a.gallery_subtitle} items={[1,2,3].map(i=>({src:a[`gallery_image_${i}`],caption:a[`gallery_caption_${i}`]}))}/>
    </section>
    <ShowcaseProducts/>
    {config?.support_url&&config.support_url!=='https://t.me/'&&<section className="social-section"><button className="button secondary" onClick={()=>visit(config.support_url)}><MessageCircle size={18}/>{a.support_label}</button></section>}
  </div>;
}
export function ShowcaseAccount() {
  const {user,isAdmin,config}=useApp();
  return <div className="social-page"><header className="social-page-heading"><h1>我的帳號</h1></header>
    <div className="account-identity"><TelegramAvatar user={user} className="social-avatar"/><h2>{user?[user.first_name,user.last_name].filter(Boolean).join(' '):'訪客'}</h2>{user?.username&&<p>@{user.username}</p>}</div>
    <div className="account-links"><Link to="/">返回展示首頁<ArrowRight size={18}/></Link>{config?.support_url&&config.support_url!=='https://t.me/'&&<button onClick={()=>visit(config.support_url)}>聯絡客服<ExternalLink size={18}/></button>}{isAdmin&&<Link to="/admin">管理員後台<ArrowRight size={18}/></Link>}</div>
  </div>;
}
